<template lang="pug">
el-popover(:placement="place" :width="width" :trigger="trig" :popper-class="cls")
  slot(name="reference" slot="reference")
  slot
</template>

<script type="text/javascript">
export default {
  name: 'StrPop',
  props: ['w', 'trigger', 'placement', 'popClass'],
  data() {
    return {
      place: this.placement || 'top-end',
      trig: this.trigger || 'hover',
      width: this.w || '350',
      cls: this.popClass || ''
    }
  }
}
</script>
